import { useQuery } from "@tanstack/react-query";
import { TrendingUp, Building2, Search, Clock } from "lucide-react";
import { taxonomyList } from "../../../services/taxonomyService";
import { toast } from "react-toastify";
import FlexibleSelect from "../../form/select/FlexibleSelect";

const JobFilterBar = ({ setActiveTab, keyword, setKeyword, setFilters, setDepartment, setExperience, onSearch }) => {
  const jobType = [
    { name: "All", value: "" },
    { name: "Full Time", value: "full-time" },
    { name: "Part Time", value: "part-time" },
    { name: "Remote", value: "remote" },
    { name: "Internship", value: "internship" },
  ];

  const { data: jobDepartmentData } = useQuery({
    queryKey: ["department"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 100,
        type: "department",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });
  const { data: jobExperienceData } = useQuery({
    queryKey: ["experience"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 100,
        type: "experience",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const { data: jobSalaryData } = useQuery({
    queryKey: ["salary-range"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 100,
        type: "salary-range",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  return (
    <div className="bg-emeraldPrimary py-10 mb-10">
      <div className="mx-[95px] px-4">
        <div className="flex flex-col md:flex-row md:justify-start md:items-center gap-8">
          {/* Filters */}
          <div className="flex flex-col md:flex-row gap-8 flex-wrap md:flex-nowrap flex-1 md:max-w-5xl">
            <div className="relative flex-1 min-w-[200px]">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 w-5 h-5 pointer-events-none" />
              <input
                type="text"
                placeholder="Search Jobs..."
                className="w-full pl-10 pr-4 py-2 rounded border-0 text-gray-600 placeholder-gray-600 bg-white focus:outline-none"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>

            <div className="relative flex-1 min-w-[200px]">
              <Clock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 w-5 h-5 pointer-events-none" />
              <FlexibleSelect
                isSearch={true}
                dropdownData={jobType}
                placeholder="Job Type"
                onChange={(val) => {setActiveTab(val)}}
                valueKey={jobType?.value}
                displayKey={jobType?.name}
              />
            </div>

            <div className="relative flex-1 min-w-[200px]">
              <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 w-5 h-5 pointer-events-none" />
              {/* <select
                className="w-full pl-10 pr-4 py-2 rounded border-0 text-gray-600 bg-white appearance-none focus:outline-none"
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="">Select Departments</option>
                {jobDepartmentData?.data.map((dep) => (
                  <option value={dep?._id}>{dep?.title}</option>
                ))}
              </select> */}

              <FlexibleSelect
                isSearch={true}
                dropdownData={jobDepartmentData?.data?.map((dep) => ({ name: dep?.title, value: dep?._id }))}
                placeholder="Department"
              />
            </div>

            <div className="relative flex-1 min-w-[200px]">
              <TrendingUp className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 w-5 h-5 pointer-events-none" />
              {/* <select
                className="w-full pl-10 pr-4 py-2 rounded border-0 text-gray-600 bg-white appearance-none focus:outline-none"
                onChange={(e) => setExperience(e.target.value)}
              >
                <option value="">Experience Level</option>
                {jobExperienceData?.data.map((exp) => (
                  <option value={exp?._id}>{exp?.title}</option>
                ))}
              </select> */}
              <FlexibleSelect
                isSearch={true}
                dropdownData={jobExperienceData?.data?.map((dep) => ({ name: dep?.title, value: dep?._id }))}
                placeholder="Experience"
              />
            </div>

            <div className="relative flex-1 min-w-[200px]">
              <TrendingUp className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 w-5 h-5 pointer-events-none" />
              {/* <select
                className="w-full pl-10 pr-4 py-2 rounded border-0 text-gray-600 bg-white appearance-none focus:outline-none"
                onChange={(e) => setExperience(e.target.value)}
              >
                <option value="">Experience Level</option>
                {jobExperienceData?.data.map((exp) => (
                  <option value={exp?._id}>{exp?.title}</option>
                ))}
              </select> */}
              <FlexibleSelect
                isSearch={true}
                dropdownData={jobSalaryData?.data?.map((dep) => ({ name: `${dep?.range?.unit==="usd"?"$":"₹"}${dep?.range?.min}-${dep?.range?.unit==="usd"?"$":"₹"}${dep?.range?.max}`, value: dep?._id }))}
                placeholder="Salary Range"
              />
            </div>
          </div>

          {/* Search Button */}
          {/* <div className="w-full md:w-auto">
            <button className="w-full md:w-auto bg-gray-900 text-white py-2 px-6 rounded border-0 hover:bg-gray-800 transition" onClick={onSearch}>
              Search
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default JobFilterBar;
